<template lang="pug">
tr(v-bind:class='{none:!user.action, insert:user.action === `insert`, update:user.action === `update`, delete:user.action === `delete`}')
  td.name
    p(v-show='!editMode') {{user.name}}
    input.form-control(type='text' v-model='user.name' v-show='editMode' placeholder='ユーザ名を入力してください'
      v-bind:class='{invalid:$v.user.name.$invalid}'
    )
    p.invalid(v-bind:class='{invalid:$v.user.name.$invalid}')
      span(v-show='!$v.user.name.maxLength') 50文字以下
  td.name
    p(v-show='!editMode') {{user.kana}}
    input.form-control(type='text' v-model='user.kana' v-show='editMode' placeholder='ユーザ名(カナ)を入力してください'
      v-bind:class='{invalid:$v.user.kana.$invalid}'
    )
    p.invalid(v-bind:class='{invalid:$v.user.kana.$invalid}')
      span(v-show='!$v.user.kana.maxLength') 100文字以下
  td.mail
    p(v-show='!editMode') {{user.mail}}
    input.form-control(type='text' v-model='user.mail' v-show='editMode' placeholder='メールアドレスを入力してください'
      v-bind:class='{invalid:$v.user.mail.$invalid}'
    )
    p.invalid(v-bind:class='{invalid:$v.user.name.$invalid}')
      span(v-show='!$v.user.mail.email') 不正なメールアドレス
      span(v-show='!$v.user.mail.maxLength') 200文字以下
  td.password
    p(v-show='!editMode') {{passwordMask}}
    input.form-control(type='password' v-model='user.password' v-show='editMode' placeholder='パスワードを入力してください'
      v-bind:class='{invalid:$v.user.password.$invalid}'
    )
    p.invalid(v-bind:class='{invalid:$v.user.name.$invalid}')
      span(v-show='!$v.user.password.minLength') 8文字以上20文字以下
      span(v-show='!$v.user.password.maxLength') 8文字以上20文字以下
      span(v-show='!$v.user.password.ascii') 半角英数記号
  td.state
    label(v-show='editMode && user.admin == 0')
      input.checkbox01-input(type='checkbox' v-model='user.use' v-bind:true-value='1' v-bind:false-value='0')
      span.checkbox01-parts
    p {{checkState}}
  td.admin
    // label(v-show='editMode')
      // input.checkbox01-input(type='checkbox' v-model='user.admin' disabled='disabled')
      // span.checkbox01-parts
    // 管理者権限は基本的には付与できない（登録時最初のユーザのみが管理者）
    p {{admin}}
  td.action
    button.customsmallbutton.btn.btn-primary(@click='edit' v-show='!editMode && user.action !== `delete`') 編集
    button.customsmallbutton.btn.btn-danger(@click='del' v-show='editMode && user.action === `update`') 削除
    button.customsmallbutton.btn.btn-default(@click='cancel' v-show='(!editMode && user.action ===`delete`) || editMode && user.action === `insert`') 取消
</template>

<script>
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
import { ascii } from '@/validators'

export default {
  props: ['data'],
  data () {
    return {
      editMode: false,
      user: this.data
    }
  },
  validations: {
    user: {
      name: { required, maxLength: maxLength(50) },
      kana: { required, maxLength: maxLength(100) },
      mail: { required, email, maxLength: maxLength(200) },
      password: { required, minLength: minLength(8), maxLength: maxLength(20), ascii }
    }
  },
  computed: {
    // es6の() => だと失敗する
    passwordMask: function () {
      if (this.user.password) {
        // 見せる文字を2つ選択する
        let ret = this.user.password.substr(0, 2)
        let last = this.user.password.substr(2)
        let lastLen = last.length
        for (let i = 0; i < lastLen; i++) {
          ret += '●'
        }
        return ret
      } else {
        return null
      }
    },
    checkState: function () {
      return Number(this.user.use) ? '利用中' : '利用禁止'
    },
    admin: function () {
      return Number(this.user.admin) ? '管理者' : '一般'
    }
  },
  created () {
    if (this.user.action === 'insert') {
      this.editMode = true
    } else {
      this.user.action = ''
    }
  },
  methods: {
    edit () {
      this.editMode = true
      this.user.action = 'update'
    },
    del () {
      this.editMode = false
      this.user.action = 'delete'
    },
    cancel () {
      // 新規の取消
      if (this.editMode && this.user.action === 'insert') {
        // parentに要素削除を要求
        this.$emit('remove')
      } else {
        this.editMode = true
        this.user.action = 'update'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.datatable
  td
    height: 52px
    vertical-align: top
  p
    width: 100%
    padding: 0
    margin: 0
  p.invalid
    color: red
  td.name, td.password, td.mail
    margin-left: 10px
    p
      margin-left: 10px
  td.name, td.kana
    width: 300px
  td.password
    width: 200px
  td.mail
    width: auto
  td.admin, td.state, td.action
    width: 100px
    text-align: center
  .btn
    padding: 3px 10px
    margin: 0
  .checkbox01-parts
    padding-left: 0
  .insert
    background-color: #FFFBC5
  .update
    background-color: #C6F1C7
  .delete
    background-color: gray
    p
      color: white
</style>



// WEBPACK FOOTER //
// Accounts_Row.vue?547472d3